/**
 * Constants representing locations within the navigation system where errors might occur.
 * These help in identifying the source of errors for logging and debugging purposes.
 */
export const ERROR_LOCATION__CUSTOMIZATION_MODAL = 'customization-modal' as const;
export const ERROR_LOCATION__DRAG_AND_DROP = 'drag-and-drop' as const;
export const ERROR_LOCATION__GLOBAL_MORE_MENU = 'global-more-menu' as const;
export const ERROR_LOCATION__GLOBAL_SHORTCUTS = 'global-shortcuts' as const;
export const ERROR_LOCATION__GLOBAL_SIDE_NAVIGATION = 'global-side-navigation' as const;
export const ERROR_LOCATION__GSN_NAV_ITEM_ACTIONS = 'global-side-navigation-item' as const;
export const ERROR_LOCATION__GSN_MAIN_NAV_ITEM = 'gsn-main-nav-item' as const;
